import { render, staticRenderFns } from "./Disabled.vue?vue&type=template&id=90e0a420&scoped=true&"
import script from "./Disabled.vue?vue&type=script&lang=js&"
export * from "./Disabled.vue?vue&type=script&lang=js&"
import style0 from "./Disabled.vue?vue&type=style&index=0&id=90e0a420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e0a420",
  null
  
)

export default component.exports